import { IconConfig } from "../types";

export const furnished: IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 79.067 54.884",
  elements: [
    {
      type: 'g',
      id: "meublee_Groupe_2636",
      className: "Groupe 2636",
      transform: "translate(-0.25 -15.25)",
      children: [
        {
          type: 'g',
          id: "meublee_Groupe_2635",
          className: "Groupe 2635",
          transform: "translate(0.5 15.5)",
          children: [
            {
              type: 'path',
              id: "meublee_Tracé_2406",
              className: "Tracé 2406",
              d: "M2.12,82.5h-1a.623.623,0,0,0,0,1.246h1a.623.623,0,0,0,0-1.246Z",
              transform: "translate(-0.5 -29.605)",
              strokeWidth: "0.5"
            },
            {
              type: 'path',
              id: "meublee_Tracé_2407",
              className: "Tracé 2407",
              d: "M78.4,28.148,72.43,15.971a.9.9,0,0,0-.707-.471H63.784a.755.755,0,0,0-.707.471L57.1,28.148a.917.917,0,0,0,0,.786.8.8,0,0,0,.629.393h3.144V33.8a.786.786,0,0,0,1.572,0V29.248h2.436v5.185a.715.715,0,0,0-.629.314c-2.358,3.064-2.672,6.128-.865,9.113H60.8V39.618a6.738,6.738,0,0,0-5.5-6.6V31.133a.786.786,0,0,0-1.572,0v1.728a6.651,6.651,0,0,0-6.288,6.678v4.242H46.414A9.322,9.322,0,0,0,39.5,40.717H27.473a11.363,11.363,0,0,1-.314-2.75,22.476,22.476,0,0,1,.236-2.671,14.66,14.66,0,0,0,.079-6.913.781.781,0,0,0-.786-.55,1.686,1.686,0,0,0-.943.314.388.388,0,0,1-.236.079c-3.773,0-7.388-1.571-11.475-.393a.853.853,0,0,0-.55.943,12.5,12.5,0,0,1-.079,5.656l-.079.55v.236A6.369,6.369,0,0,0,8.845,32.7V25.87a4.645,4.645,0,0,1,4.637-4.635h35.6a4.645,4.645,0,0,1,4.637,4.635v2.043a.786.786,0,0,0,1.572,0V25.87a6.221,6.221,0,0,0-6.209-6.206h-35.6A6.221,6.221,0,0,0,7.273,25.87V32.7a6.7,6.7,0,0,0-5.895,6.6V53.444a.742.742,0,0,0,.786.786.742.742,0,0,0,.786-.786V39.3a5.109,5.109,0,0,1,10.218,0V52.5H10.653a.786.786,0,1,0,0,1.571H43.9v9.349H4.837a1.945,1.945,0,0,1-1.965-1.964V56.508a.742.742,0,0,0-.786-.786.742.742,0,0,0-.786.786v4.949a3.521,3.521,0,0,0,3.537,3.535H8.374V67.82H6.016a.786.786,0,1,0,0,1.571H76.831a.786.786,0,1,0,0-1.571H76.6V46.3a2.784,2.784,0,0,0-2.751-2.75H72.115a8.684,8.684,0,0,0-.707-9.113.715.715,0,0,0-.629-.314h-.314V29.248h7.152a.7.7,0,0,0,.629-.393.625.625,0,0,0,.157-.707Zm-29.4,11.47a5.109,5.109,0,0,1,10.218,0V43.86H49.008ZM45.471,68.134V57.529H75.023V68.056H45.471Zm-30.5-33.152a14.763,14.763,0,0,0,.236-5.578c3.38-.707,6.6.628,10.375.628a1.85,1.85,0,0,0,.629-.157,15.433,15.433,0,0,1-.314,5.342,15.253,15.253,0,0,0-.236,2.985,15.739,15.739,0,0,0,.236,2.514,19.055,19.055,0,0,1-3.694.236c-2.515-.393-4.716-1.021-7.231-.55-.157-.864-.157-1.728-.236-2.514a9.542,9.542,0,0,1,.236-2.907Zm-.314,6.992a10.179,10.179,0,0,1,3.773-.157,10.181,10.181,0,0,0-3.773,3.3Zm0,10.841V50.38A7.914,7.914,0,0,1,22.6,42.446h16.82a7.756,7.756,0,0,1,5.345,2.121,2.661,2.661,0,0,0-.943,2.043v6.285c-6.759-.079-22.243-.079-29.159-.079ZM43.9,68.134H17.412V65.306H43.9Zm-33.954,0V65.306H15.84v2.828ZM75.023,46.609v9.427H45.471V46.609a1.208,1.208,0,0,1,1.179-1.178H73.923a1.142,1.142,0,0,1,1.1,1.178Zm-4.637-2.75h-5.03a5.972,5.972,0,0,1,0-7.856h5.03C72.037,38.518,71.958,41.11,70.386,43.86Zm-1.493-9.427H66.535V29.248h2.358Zm-9.825-6.756,5.187-10.605h7l5.187,10.605Z",
              transform: "translate(-0.802 -15.5)",
              strokeWidth: "0.5"
            },
            {
              type: 'path',
              id: "meublee_Tracé_2408",
              className: "Tracé 2408",
              d: "M74.83,56.4a2.433,2.433,0,0,0-2.43,2.43,2.43,2.43,0,1,0,2.43-2.43Zm0,3.613a1.183,1.183,0,0,1-1.184-1.184,1.184,1.184,0,1,1,1.184,1.184Z",
              transform: "translate(-14.989 -23.465)",
              strokeWidth: "0.5"
            },
            {
              type: 'path',
              id: "meublee_Tracé_2409",
              className: "Tracé 2409",
              d: "M74.83,71.9a2.433,2.433,0,0,0-2.43,2.43,2.43,2.43,0,1,0,2.43-2.43Zm0,3.551a1.184,1.184,0,1,1,0-2.367,1.184,1.184,0,1,1,0,2.367Z",
              transform: "translate(-14.989 -25.609)",
              strokeWidth: "0.5"
            }
          ]
        }
      ]
    }
  ]
}
